import React, { FC } from 'react';

import ProductCard from '~/src/components/ProductCard';
import { getPriceOptions } from '~/src/entities/equipment';
import { convertShopPrices } from '~/src/entities/price';
import type { IProps, PriceOptionProps } from '~/src/features/videocontrol/pageBlocks/StepsInstall/CameraCard/types';
import { getPayload } from '~/src/features/videocontrol/pageBlocks/StepsInstall/CameraCard/utils';
import { useRequisitionContext } from '~/src/features/videocontrol/Provider/useRequisitionContext';

export const CameraCard: FC<IProps> = ({ product, activeTabLocation }) => {
    const { addCameraDispatch, cameras, removeCameraDispatch } = useRequisitionContext();
    const cameraType = Array.isArray(product?.props) && product.props[0].value === 'outside' ? 'Внешняя камера' : 'Внутренняя камера';

    const onClickHandler = (options: PriceOptionProps) => {
        const payload = getPayload(options, product, activeTabLocation);
        if (cameras[product.id]) {
            removeCameraDispatch(product.id);
            // Что бы при удалении карточки аналитика второй раз не срабатывала
            return true;
        } else {
            addCameraDispatch(payload);
        }
    };

    return (
        <ProductCard
            key={product.id}
            image={product.image}
            imageWebp={product.image_webp}
            categoryTitle={cameraType}
            categoryName={product.category?.name}
            name={product.title}
            shortName={product.title_short}
            description={product.body}
            backgroundColorData={{ bgImg: '#20252f', bgCard: '#20252f' }}
            priceOptions={getPriceOptions(convertShopPrices(product))}
            orderText={cameras[product.id] ? 'Добавлено' : 'Добавить'}
            isDarkTheme={true}
            detailHandler={onClickHandler}
        />
    );
};
